import {Component, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {Collaborator} from '../../../../feature-modules/user/model/collaborator';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';
import {ApiService} from '../../../service/api.service';
import {User} from '../../../class/central/user';
import {UserGroup} from '../../../class/user/user-group';
import {CompanyCollaborator} from '../../../class/company-code';
import {CollaboratorInfo} from '../../../class/user/collaborator-info';

@Component({
  selector: 'app-import-collaborator-dialog',
  templateUrl: './import-collaborator-dialog.component.html',
  styleUrls: ['./import-collaborator-dialog.component.css']
})
export class ImportCollaboratorDialogComponent extends BaseDialog<CompanyCollaborator> implements OnInit {

  collaborators: Collaborator[];

  @Input()
  filterByGroup: UserGroup;

  searchKey: string;
  loading: boolean;

  constructor(dialogRef: NbDialogRef<CompanyCollaborator>, route: Router, private apiService: ApiService) {
    super(dialogRef, route);
  }

  ngOnInit() {
    this.loading = true;
    this.apiService.getCollaborators().subscribe(collaborators => {
      this.collaborators = collaborators;
      this.loading = false;
    });
  }

  filter(user: User): boolean {
    let ret = false;

    if (this.filterByGroup) {
      const userGroup = user.userGroup;
      ret = userGroup.name !== this.filterByGroup.name;
    }

    return ret;
  }

  close(result?) {
    let collaboratorInfo = null;

    if (result){
      //convert to Collaborator info
      collaboratorInfo = new CollaboratorInfo()
      collaboratorInfo.fullName = result.name + " " + result.surname;
      collaboratorInfo.groupName = result.groupName;
      collaboratorInfo.email = result.email;
    }

    super.close(collaboratorInfo);
  }
}
